const STORAGE_PREFIX = "ia_adminReviewsLastSeen:";

function readStorageKey(userId) {
   const id = Number(userId);
   if (!Number.isFinite(id) || id <= 0) return null;
   return `${STORAGE_PREFIX}${id}`;
}

export function getAdminReviewsLastSeenAt(userId) {
   if (typeof window === "undefined") return 0;
   const key = readStorageKey(userId);
   if (!key) return 0;

   const raw = window.localStorage.getItem(key);
   const parsed = Number(raw);
   return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}

export function markAdminReviewsSeen(userId, timestamp = Date.now()) {
   if (typeof window === "undefined") return;
   const key = readStorageKey(userId);
   if (!key) return;

   const next = Number(timestamp);
   if (!Number.isFinite(next) || next <= 0) return;
   window.localStorage.setItem(key, String(next));
}

export function countUnreadAdminReviews(ratings = [], userId) {
   const lastSeenAt = getAdminReviewsLastSeenAt(userId);
   if (!lastSeenAt) return Array.isArray(ratings) ? ratings.length : 0;

   return (Array.isArray(ratings) ? ratings : []).filter((rating) => {
      const createdAt = new Date(
         rating?.createdAt || rating?.updatedAt || 0,
      ).getTime();
      return Number.isFinite(createdAt) && createdAt > lastSeenAt;
   }).length;
}
